import I18n from 'I18n';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import FakeConnector from 'automation-ui-canvas/components/canvas/next-action-recommender/components/FakeConnector';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRibbon from 'UIComponents/ribbon/UIRibbon';
import { CARD_WIDTH, CARD_HEIGHT } from 'automation-ui-flow-core/canvas/graphConstants';
import { StyledZoomedOutGhostedActionCard, StyledZoomedOutActionCardHeader, StyledActionIcon, StyledActionCardHeader, StyledActionTypeHeader, StyledActionTitle, StyledGhostedActionCard, StyledGhostedActionCardFooter, StyledGhostedActionCardBody } from 'automation-ui-flow-core/canvas/AutomationBuilderCardStyles';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import InlineFeedback from 'ai-components-ui-library/components/feedback/InlineFeedback';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import { useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledUIRibbon = styled(UIRibbon).withConfig({
  displayName: "NextRecommendedActionCard__StyledUIRibbon",
  componentId: "zwsm67-0"
})(["top:15px;"]);
const NextRecommendedActionCard = ({
  width = CARD_WIDTH,
  height = CARD_HEIGHT,
  layout = 'default',
  onClickAddAction,
  onClickDismiss,
  onClickThumbsUp,
  onClickThumbsDown,
  headerTitle,
  headerImage,
  headerIcon,
  content
}) => {
  const {
    usageTracker
  } = useContext(UsageTrackerContext);
  const CardContainer = layout === 'zoomed-out' ? StyledZoomedOutGhostedActionCard : StyledGhostedActionCard;
  const CardHeader = layout === 'zoomed-out' ? StyledZoomedOutActionCardHeader : StyledActionCardHeader;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(CardContainer, {
      onClick: () => {},
      disabled: true,
      $width: width,
      $height: height,
      $scale: layout === 'zoomed-out' ? 2 : 1,
      onMouseDown: event => {
        // Prevent panning the canvas when dragging within a card
        event.nativeEvent.stopImmediatePropagation();
        event.stopPropagation();
      },
      children: [/*#__PURE__*/_jsxs(CardHeader, {
        $showIcon: true,
        children: [layout === 'default' && /*#__PURE__*/_jsx(StyledUIRibbon, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "recommendedActionCard.cardRibbon"
          })
        }), /*#__PURE__*/_jsx(StyledActionIcon, {
          className: layout === 'zoomed-out' ? 'm-right-2' : 'm-right-3',
          name: headerIcon,
          src: headerImage,
          alt: "" // alt text would be redundant since the action title comes next
          ,
          size: 19,
          showCircle: layout !== 'zoomed-out'
        }), /*#__PURE__*/_jsx(StyledActionTypeHeader, {
          children: /*#__PURE__*/_jsx(StyledActionTitle, {
            className: "m-y-0",
            children: headerTitle
          })
        })]
      }), /*#__PURE__*/_jsxs(StyledGhostedActionCardBody, {
        children: [content, /*#__PURE__*/_jsx(InlineFeedback
        // chirpContextAiObject does not contain a messageId. Using a placeholder for now.
        , {
          messageId: 123,
          onPositiveFeedback: onClickThumbsUp,
          onNegativeFeedback: ({
            feedbackMessage = ''
          }) => {
            onClickThumbsDown(feedbackMessage);
          },
          usageTracker: usageTracker,
          negativeFeedbackPopoverTitle: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "recommendedActionCard.negativeFeedbackPopover.title"
          }),
          negativeFeedbackPopoverBody: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "recommendedActionCard.negativeFeedbackPopover.body"
          }),
          negativeFeedbackPopoverTextAreaPlaceholder: I18n.text('recommendedActionCard.negativeFeedbackPopover.textAreaPlaceholder')
        })]
      }), /*#__PURE__*/_jsx(StyledGhostedActionCardFooter, {
        children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
          children: [/*#__PURE__*/_jsx(UIButton, {
            use: "tertiary",
            size: "extra-small",
            onClick: onClickAddAction,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "recommendedActionCard.footerButtons.add"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "tertiary-extra-light",
            size: "extra-small",
            onClick: onClickDismiss,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "recommendedActionCard.footerButtons.dismiss"
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(FakeConnector, {
      children: "\xA0"
    })]
  });
};
export default NextRecommendedActionCard;